import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/@core/utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent extends BaseComponent {
  @Input() modalRef: BsModalRef | undefined;
  @Input() positiveResponse?: string;
  @Input() title?: string;
  @Input() hideNegativeResponseBtn?: boolean;
  @Output() onAction: EventEmitter<boolean> = new EventEmitter();
  @Input() closeButtonName = 'No';
  constructor(private readonly modalService: BsModalService) {
    super();
  }

  modalResponse(selection: boolean): void {
    this.onAction.emit(selection);
    this.modalService.hide();
    this.hideModal();
  }

  hideModal(): void {
    this.modalRef?.hide();
  }
}
